import React, { useReducer } from "react";

export function useCombineReducer(reducers) {
  const [state, dispatch] = useReducer(
    (state, action) => {
      const newState = {};
      Object.keys(reducers).forEach((key) => {
        newState[key] = reducers[key](state[key], action);
      });
      return newState;
    },
    {},
    () => {
      const newState = {};
      Object.keys(reducers).forEach((key) => {
        newState[key] = reducers[key](undefined, { type: undefined });
      });
      return newState;
    }
  );

  return [state, dispatch];
}
